export default [
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/73jBynjsVtofjRpdpRAJGk'
          },
          href: 'https://api.spotify.com/v1/artists/73jBynjsVtofjRpdpRAJGk',
          id: '73jBynjsVtofjRpdpRAJGk',
          name: 'Dimitri Vegas & Like Mike',
          type: 'artist',
          uri: 'spotify:artist:73jBynjsVtofjRpdpRAJGk'
        },
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/2wX6xSig4Rig5kZU6ePlWe'
          },
          href: 'https://api.spotify.com/v1/artists/2wX6xSig4Rig5kZU6ePlWe',
          id: '2wX6xSig4Rig5kZU6ePlWe',
          name: 'KSHMR',
          type: 'artist',
          uri: 'spotify:artist:2wX6xSig4Rig5kZU6ePlWe'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/6Ds82KME1uLRZBx1V2JI5E'
      },
      href: 'https://api.spotify.com/v1/albums/6Ds82KME1uLRZBx1V2JI5E',
      id: '6Ds82KME1uLRZBx1V2JI5E',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/b177cadc71150d06963066fa92676e63e1d6d376',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/f8876721de5ced65b0fde16ec41c62317968dae5',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/003bf245731d0eb3ec286feb6bac0d57d5f75233',
          width: 64
        }
      ],
      name: 'Opa',
      type: 'album',
      uri: 'spotify:album:6Ds82KME1uLRZBx1V2JI5E'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/73jBynjsVtofjRpdpRAJGk'
        },
        href: 'https://api.spotify.com/v1/artists/73jBynjsVtofjRpdpRAJGk',
        id: '73jBynjsVtofjRpdpRAJGk',
        name: 'Dimitri Vegas & Like Mike',
        type: 'artist',
        uri: 'spotify:artist:73jBynjsVtofjRpdpRAJGk'
      },
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/2wX6xSig4Rig5kZU6ePlWe'
        },
        href: 'https://api.spotify.com/v1/artists/2wX6xSig4Rig5kZU6ePlWe',
        id: '2wX6xSig4Rig5kZU6ePlWe',
        name: 'KSHMR',
        type: 'artist',
        uri: 'spotify:artist:2wX6xSig4Rig5kZU6ePlWe'
      }
    ],
    disc_number: 1,
    duration_ms: 206250,
    explicit: false,
    external_ids: {
      isrc: 'BEG851800030'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/7wxeGWvf8HNuUeK4k06mOr'
    },
    href: 'https://api.spotify.com/v1/tracks/7wxeGWvf8HNuUeK4k06mOr',
    id: '7wxeGWvf8HNuUeK4k06mOr',
    is_playable: true,
    name: 'Opa',
    popularity: 63,
    preview_url:
      'https://p.scdn.co/mp3-preview/942d21832de6e0967267a4e6a1a5ecfd02177a56?cid=774b29d4f13844c495f206cafdad9c86',
    track_number: 1,
    type: 'track',
    uri: 'spotify:track:7wxeGWvf8HNuUeK4k06mOr'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/64KEffDW9EtZ1y2vBYgq8T'
          },
          href: 'https://api.spotify.com/v1/artists/64KEffDW9EtZ1y2vBYgq8T',
          id: '64KEffDW9EtZ1y2vBYgq8T',
          name: 'Marshmello',
          type: 'artist',
          uri: 'spotify:artist:64KEffDW9EtZ1y2vBYgq8T'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/0xi4cOWPUHjctyYU8ypCOB'
      },
      href: 'https://api.spotify.com/v1/albums/0xi4cOWPUHjctyYU8ypCOB',
      id: '0xi4cOWPUHjctyYU8ypCOB',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/e1f9f132c2e7360ec9645074c1f205662835c867',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/14d76cd305772045313a8fcd9f2ff880db67e9d0',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/08816b6577b8bd6ae5e15e8ad1e0e05824b1f8cc',
          width: 64
        }
      ],
      name: 'Joytime II',
      type: 'album',
      uri: 'spotify:album:0xi4cOWPUHjctyYU8ypCOB'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/64KEffDW9EtZ1y2vBYgq8T'
        },
        href: 'https://api.spotify.com/v1/artists/64KEffDW9EtZ1y2vBYgq8T',
        id: '64KEffDW9EtZ1y2vBYgq8T',
        name: 'Marshmello',
        type: 'artist',
        uri: 'spotify:artist:64KEffDW9EtZ1y2vBYgq8T'
      }
    ],
    disc_number: 1,
    duration_ms: 177464,
    explicit: false,
    external_ids: {
      isrc: 'TCADR1866828'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/6pbhkfdG5RvTJaC3VKPaJn'
    },
    href: 'https://api.spotify.com/v1/tracks/6pbhkfdG5RvTJaC3VKPaJn',
    id: '6pbhkfdG5RvTJaC3VKPaJn',
    is_playable: true,
    name: 'Rooftops',
    popularity: 66,
    preview_url:
      'https://p.scdn.co/mp3-preview/26b0ebf2ec8c31c80d286d1330fa58e0d9b7c8b4?cid=774b29d4f13844c495f206cafdad9c86',
    track_number: 3,
    type: 'track',
    uri: 'spotify:track:6pbhkfdG5RvTJaC3VKPaJn'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/7wg1qvie3KqDNQbAkTdbX0'
          },
          href: 'https://api.spotify.com/v1/artists/7wg1qvie3KqDNQbAkTdbX0',
          id: '7wg1qvie3KqDNQbAkTdbX0',
          name: 'Louis The Child',
          type: 'artist',
          uri: 'spotify:artist:7wg1qvie3KqDNQbAkTdbX0'
        },
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/0FL2d6iFFNAV3yBUbXjZ1U'
          },
          href: 'https://api.spotify.com/v1/artists/0FL2d6iFFNAV3yBUbXjZ1U',
          id: '0FL2d6iFFNAV3yBUbXjZ1U',
          name: 'Wafia',
          type: 'artist',
          uri: 'spotify:artist:0FL2d6iFFNAV3yBUbXjZ1U'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/1hgHJzbzZskVlYIZ57FCVQ'
      },
      href: 'https://api.spotify.com/v1/albums/1hgHJzbzZskVlYIZ57FCVQ',
      id: '1hgHJzbzZskVlYIZ57FCVQ',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/6e5d779853d830b61e51d124508ca1500e1236f2',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/04a2ff740c285484885f15418d02c57a01ea08cd',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/5e75af0d16b76d65b6bccd93ce3cb3f00df9e92c',
          width: 64
        }
      ],
      name: 'Better Not (feat. Wafia)',
      type: 'album',
      uri: 'spotify:album:1hgHJzbzZskVlYIZ57FCVQ'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/7wg1qvie3KqDNQbAkTdbX0'
        },
        href: 'https://api.spotify.com/v1/artists/7wg1qvie3KqDNQbAkTdbX0',
        id: '7wg1qvie3KqDNQbAkTdbX0',
        name: 'Louis The Child',
        type: 'artist',
        uri: 'spotify:artist:7wg1qvie3KqDNQbAkTdbX0'
      },
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/0FL2d6iFFNAV3yBUbXjZ1U'
        },
        href: 'https://api.spotify.com/v1/artists/0FL2d6iFFNAV3yBUbXjZ1U',
        id: '0FL2d6iFFNAV3yBUbXjZ1U',
        name: 'Wafia',
        type: 'artist',
        uri: 'spotify:artist:0FL2d6iFFNAV3yBUbXjZ1U'
      }
    ],
    disc_number: 1,
    duration_ms: 222865,
    explicit: false,
    external_ids: {
      isrc: 'USUM71804511'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/447yWcDPg1ddgcHBLGpJC0'
    },
    href: 'https://api.spotify.com/v1/tracks/447yWcDPg1ddgcHBLGpJC0',
    id: '447yWcDPg1ddgcHBLGpJC0',
    is_playable: true,
    name: 'Better Not (feat. Wafia)',
    popularity: 80,
    preview_url: null,
    track_number: 1,
    type: 'track',
    uri: 'spotify:track:447yWcDPg1ddgcHBLGpJC0'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/1HxJeLhIuegM3KgvPn8sTa'
          },
          href: 'https://api.spotify.com/v1/artists/1HxJeLhIuegM3KgvPn8sTa',
          id: '1HxJeLhIuegM3KgvPn8sTa',
          name: 'Jack Ü',
          type: 'artist',
          uri: 'spotify:artist:1HxJeLhIuegM3KgvPn8sTa'
        },
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/5he5w2lnU9x7JFhnwcekXX'
          },
          href: 'https://api.spotify.com/v1/artists/5he5w2lnU9x7JFhnwcekXX',
          id: '5he5w2lnU9x7JFhnwcekXX',
          name: 'Skrillex',
          type: 'artist',
          uri: 'spotify:artist:5he5w2lnU9x7JFhnwcekXX'
        },
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/5fMUXHkw8R8eOP2RNVYEZX'
          },
          href: 'https://api.spotify.com/v1/artists/5fMUXHkw8R8eOP2RNVYEZX',
          id: '5fMUXHkw8R8eOP2RNVYEZX',
          name: 'Diplo',
          type: 'artist',
          uri: 'spotify:artist:5fMUXHkw8R8eOP2RNVYEZX'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/6bfkwBrGYKJFk6Z4QVyjxd'
      },
      href: 'https://api.spotify.com/v1/albums/6bfkwBrGYKJFk6Z4QVyjxd',
      id: '6bfkwBrGYKJFk6Z4QVyjxd',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/b962d9c0353ef080806b5599cd6618ef0b266880',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/e3d922ad543fa3158ae7f4507fb23d0cd2004143',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/97e4a1c40ac374a49dff6480459f23e8cfea2dfe',
          width: 64
        }
      ],
      name: 'Skrillex and Diplo present Jack Ü',
      type: 'album',
      uri: 'spotify:album:6bfkwBrGYKJFk6Z4QVyjxd'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/1HxJeLhIuegM3KgvPn8sTa'
        },
        href: 'https://api.spotify.com/v1/artists/1HxJeLhIuegM3KgvPn8sTa',
        id: '1HxJeLhIuegM3KgvPn8sTa',
        name: 'Jack Ü',
        type: 'artist',
        uri: 'spotify:artist:1HxJeLhIuegM3KgvPn8sTa'
      },
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/5he5w2lnU9x7JFhnwcekXX'
        },
        href: 'https://api.spotify.com/v1/artists/5he5w2lnU9x7JFhnwcekXX',
        id: '5he5w2lnU9x7JFhnwcekXX',
        name: 'Skrillex',
        type: 'artist',
        uri: 'spotify:artist:5he5w2lnU9x7JFhnwcekXX'
      },
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/5fMUXHkw8R8eOP2RNVYEZX'
        },
        href: 'https://api.spotify.com/v1/artists/5fMUXHkw8R8eOP2RNVYEZX',
        id: '5fMUXHkw8R8eOP2RNVYEZX',
        name: 'Diplo',
        type: 'artist',
        uri: 'spotify:artist:5fMUXHkw8R8eOP2RNVYEZX'
      },
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/1uNFoZAHBGtllmzznpCI3s'
        },
        href: 'https://api.spotify.com/v1/artists/1uNFoZAHBGtllmzznpCI3s',
        id: '1uNFoZAHBGtllmzznpCI3s',
        name: 'Justin Bieber',
        type: 'artist',
        uri: 'spotify:artist:1uNFoZAHBGtllmzznpCI3s'
      }
    ],
    disc_number: 1,
    duration_ms: 250285,
    explicit: false,
    external_ids: {
      isrc: 'USAT21500555'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/66hayvUbTotekKU3H4ta1f'
    },
    href: 'https://api.spotify.com/v1/tracks/66hayvUbTotekKU3H4ta1f',
    id: '66hayvUbTotekKU3H4ta1f',
    is_playable: true,
    name: 'Where Are Ü Now (with Justin Bieber)',
    popularity: 74,
    preview_url:
      'https://p.scdn.co/mp3-preview/edd7282e93a954b2b48cfc136aa63b0396c16406?cid=774b29d4f13844c495f206cafdad9c86',
    track_number: 9,
    type: 'track',
    uri: 'spotify:track:66hayvUbTotekKU3H4ta1f'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/1l2ekx5skC4gJH8djERwh1'
          },
          href: 'https://api.spotify.com/v1/artists/1l2ekx5skC4gJH8djERwh1',
          id: '1l2ekx5skC4gJH8djERwh1',
          name: 'Don Diablo',
          type: 'artist',
          uri: 'spotify:artist:1l2ekx5skC4gJH8djERwh1'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/3q2qy7PRpcTRk4Y7W7lo5Y'
      },
      href: 'https://api.spotify.com/v1/albums/3q2qy7PRpcTRk4Y7W7lo5Y',
      id: '3q2qy7PRpcTRk4Y7W7lo5Y',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/0f52b097d5213dd31ebb53922e1b78e885cfa7a1',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/6e260012d4df74ab1d92672133895b3f092ae219',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/8ce4ac8fb90f15beafd779ae4fb3c7ac667238f0',
          width: 64
        }
      ],
      name: 'Anthem (We Love House Music)',
      type: 'album',
      uri: 'spotify:album:3q2qy7PRpcTRk4Y7W7lo5Y'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/1l2ekx5skC4gJH8djERwh1'
        },
        href: 'https://api.spotify.com/v1/artists/1l2ekx5skC4gJH8djERwh1',
        id: '1l2ekx5skC4gJH8djERwh1',
        name: 'Don Diablo',
        type: 'artist',
        uri: 'spotify:artist:1l2ekx5skC4gJH8djERwh1'
      }
    ],
    disc_number: 1,
    duration_ms: 157024,
    explicit: false,
    external_ids: {
      isrc: 'NLZ541800051'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/7uObfbegIGow74NAVBCnRV'
    },
    href: 'https://api.spotify.com/v1/tracks/7uObfbegIGow74NAVBCnRV',
    id: '7uObfbegIGow74NAVBCnRV',
    is_playable: true,
    name: 'Anthem (We Love House Music)',
    popularity: 64,
    preview_url:
      'https://p.scdn.co/mp3-preview/a4bdb869b5c8a6e86857d4b5ab29398dcfe95fb2?cid=774b29d4f13844c495f206cafdad9c86',
    track_number: 1,
    type: 'track',
    uri: 'spotify:track:7uObfbegIGow74NAVBCnRV'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/77AiFEVeAVj2ORpC85QVJs'
          },
          href: 'https://api.spotify.com/v1/artists/77AiFEVeAVj2ORpC85QVJs',
          id: '77AiFEVeAVj2ORpC85QVJs',
          name: 'Steve Aoki',
          type: 'artist',
          uri: 'spotify:artist:77AiFEVeAVj2ORpC85QVJs'
        },
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/6VD4UEUPvtsemqD3mmTqCR'
          },
          href: 'https://api.spotify.com/v1/artists/6VD4UEUPvtsemqD3mmTqCR',
          id: '6VD4UEUPvtsemqD3mmTqCR',
          name: 'Deorro',
          type: 'artist',
          uri: 'spotify:artist:6VD4UEUPvtsemqD3mmTqCR'
        },
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/3PtCud9dIdOv4exrzdZZ1C'
          },
          href: 'https://api.spotify.com/v1/artists/3PtCud9dIdOv4exrzdZZ1C',
          id: '3PtCud9dIdOv4exrzdZZ1C',
          name: 'MAKJ',
          type: 'artist',
          uri: 'spotify:artist:3PtCud9dIdOv4exrzdZZ1C'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/2QmesDlTVu1SelSLBqb1b5'
      },
      href: 'https://api.spotify.com/v1/albums/2QmesDlTVu1SelSLBqb1b5',
      id: '2QmesDlTVu1SelSLBqb1b5',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/cb32864486bc81f82c2b04b1da78f3aa28bd8c58',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/22108f85ab070bc3529ef94eb603b3036a8a4210',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/8870ebd9098b9df19e0f66315ead694d555fac40',
          width: 64
        }
      ],
      name: 'Shakalaka (Steve Aoki, Deorro, MAKJ & Max Styler)',
      type: 'album',
      uri: 'spotify:album:2QmesDlTVu1SelSLBqb1b5'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/77AiFEVeAVj2ORpC85QVJs'
        },
        href: 'https://api.spotify.com/v1/artists/77AiFEVeAVj2ORpC85QVJs',
        id: '77AiFEVeAVj2ORpC85QVJs',
        name: 'Steve Aoki',
        type: 'artist',
        uri: 'spotify:artist:77AiFEVeAVj2ORpC85QVJs'
      },
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/6VD4UEUPvtsemqD3mmTqCR'
        },
        href: 'https://api.spotify.com/v1/artists/6VD4UEUPvtsemqD3mmTqCR',
        id: '6VD4UEUPvtsemqD3mmTqCR',
        name: 'Deorro',
        type: 'artist',
        uri: 'spotify:artist:6VD4UEUPvtsemqD3mmTqCR'
      },
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/3PtCud9dIdOv4exrzdZZ1C'
        },
        href: 'https://api.spotify.com/v1/artists/3PtCud9dIdOv4exrzdZZ1C',
        id: '3PtCud9dIdOv4exrzdZZ1C',
        name: 'MAKJ',
        type: 'artist',
        uri: 'spotify:artist:3PtCud9dIdOv4exrzdZZ1C'
      },
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/3NKKngINK1tP6BFy0WOyWk'
        },
        href: 'https://api.spotify.com/v1/artists/3NKKngINK1tP6BFy0WOyWk',
        id: '3NKKngINK1tP6BFy0WOyWk',
        name: 'Max Styler',
        type: 'artist',
        uri: 'spotify:artist:3NKKngINK1tP6BFy0WOyWk'
      }
    ],
    disc_number: 1,
    duration_ms: 176571,
    explicit: false,
    external_ids: {
      isrc: 'USUS11800150'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/0KmJ45CPuHMQpNMY42xDUl'
    },
    href: 'https://api.spotify.com/v1/tracks/0KmJ45CPuHMQpNMY42xDUl',
    id: '0KmJ45CPuHMQpNMY42xDUl',
    is_playable: true,
    name: 'Shakalaka (Steve Aoki, Deorro, MAKJ & Max Styler)',
    popularity: 64,
    preview_url:
      'https://p.scdn.co/mp3-preview/d1d083811225349c0517ab2c25f400f141bc929c?cid=774b29d4f13844c495f206cafdad9c86',
    track_number: 1,
    type: 'track',
    uri: 'spotify:track:0KmJ45CPuHMQpNMY42xDUl'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/4sTQVOfp9vEMCemLw50sbu'
          },
          href: 'https://api.spotify.com/v1/artists/4sTQVOfp9vEMCemLw50sbu',
          id: '4sTQVOfp9vEMCemLw50sbu',
          name: 'Galantis',
          type: 'artist',
          uri: 'spotify:artist:4sTQVOfp9vEMCemLw50sbu'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/7DNmxxEuJe19wNVrinaXx4'
      },
      href: 'https://api.spotify.com/v1/albums/7DNmxxEuJe19wNVrinaXx4',
      id: '7DNmxxEuJe19wNVrinaXx4',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/3ee0e67a91b6c8b4b4e16b35af09b24f90293747',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/abe78ca0898f3095e78c7afb44c7aed79f2c1b34',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/6ec79c494b6db835ef4a74619dac27cc487a5b9a',
          width: 64
        }
      ],
      name: 'The Aviary',
      type: 'album',
      uri: 'spotify:album:7DNmxxEuJe19wNVrinaXx4'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/4sTQVOfp9vEMCemLw50sbu'
        },
        href: 'https://api.spotify.com/v1/artists/4sTQVOfp9vEMCemLw50sbu',
        id: '4sTQVOfp9vEMCemLw50sbu',
        name: 'Galantis',
        type: 'artist',
        uri: 'spotify:artist:4sTQVOfp9vEMCemLw50sbu'
      }
    ],
    disc_number: 1,
    duration_ms: 183466,
    explicit: false,
    external_ids: {
      isrc: 'USAT21703589'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/1My0Hfu5dTCbYisBk9ZRGr'
    },
    href: 'https://api.spotify.com/v1/tracks/1My0Hfu5dTCbYisBk9ZRGr',
    id: '1My0Hfu5dTCbYisBk9ZRGr',
    is_playable: true,
    name: 'Hunter',
    popularity: 67,
    preview_url:
      'https://p.scdn.co/mp3-preview/9d4e50c7a54481f261467bac6edcd70307f067e6?cid=774b29d4f13844c495f206cafdad9c86',
    track_number: 7,
    type: 'track',
    uri: 'spotify:track:1My0Hfu5dTCbYisBk9ZRGr'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/64KEffDW9EtZ1y2vBYgq8T'
          },
          href: 'https://api.spotify.com/v1/artists/64KEffDW9EtZ1y2vBYgq8T',
          id: '64KEffDW9EtZ1y2vBYgq8T',
          name: 'Marshmello',
          type: 'artist',
          uri: 'spotify:artist:64KEffDW9EtZ1y2vBYgq8T'
        },
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/1HQGhla3VNj1dBmKTtVT2t'
          },
          href: 'https://api.spotify.com/v1/artists/1HQGhla3VNj1dBmKTtVT2t',
          id: '1HQGhla3VNj1dBmKTtVT2t',
          name: 'Ookay',
          type: 'artist',
          uri: 'spotify:artist:1HQGhla3VNj1dBmKTtVT2t'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/4Lp0jynclQS3WCmxJZCFOl'
      },
      href: 'https://api.spotify.com/v1/albums/4Lp0jynclQS3WCmxJZCFOl',
      id: '4Lp0jynclQS3WCmxJZCFOl',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/f88c231467b7f8d31d9e5b672edec04fb0c57075',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/050408ea00bd01e0ae9ba76abd064d64076c9b9f',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/d0ebe529bdf1cf354215d8bb604293042ff51e9b',
          width: 64
        }
      ],
      name: 'Chasing Colors (feat. Noah Cyrus)',
      type: 'album',
      uri: 'spotify:album:4Lp0jynclQS3WCmxJZCFOl'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/64KEffDW9EtZ1y2vBYgq8T'
        },
        href: 'https://api.spotify.com/v1/artists/64KEffDW9EtZ1y2vBYgq8T',
        id: '64KEffDW9EtZ1y2vBYgq8T',
        name: 'Marshmello',
        type: 'artist',
        uri: 'spotify:artist:64KEffDW9EtZ1y2vBYgq8T'
      },
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/1HQGhla3VNj1dBmKTtVT2t'
        },
        href: 'https://api.spotify.com/v1/artists/1HQGhla3VNj1dBmKTtVT2t',
        id: '1HQGhla3VNj1dBmKTtVT2t',
        name: 'Ookay',
        type: 'artist',
        uri: 'spotify:artist:1HQGhla3VNj1dBmKTtVT2t'
      },
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/55fhWPvDiMpLnE4ZzNXZyW'
        },
        href: 'https://api.spotify.com/v1/artists/55fhWPvDiMpLnE4ZzNXZyW',
        id: '55fhWPvDiMpLnE4ZzNXZyW',
        name: 'Noah Cyrus',
        type: 'artist',
        uri: 'spotify:artist:55fhWPvDiMpLnE4ZzNXZyW'
      }
    ],
    disc_number: 1,
    duration_ms: 195200,
    explicit: false,
    external_ids: {
      isrc: 'TCACY1707257'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/1VxogbO6bfygdfaCnE9oLb'
    },
    href: 'https://api.spotify.com/v1/tracks/1VxogbO6bfygdfaCnE9oLb',
    id: '1VxogbO6bfygdfaCnE9oLb',
    is_playable: true,
    name: 'Chasing Colors (feat. Noah Cyrus)',
    popularity: 61,
    preview_url:
      'https://p.scdn.co/mp3-preview/9da94fa6093992ec8f80278809311f2d3186ba33?cid=774b29d4f13844c495f206cafdad9c86',
    track_number: 1,
    type: 'track',
    uri: 'spotify:track:1VxogbO6bfygdfaCnE9oLb'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/76M2Ekj8bG8W7X2nbx2CpF'
          },
          href: 'https://api.spotify.com/v1/artists/76M2Ekj8bG8W7X2nbx2CpF',
          id: '76M2Ekj8bG8W7X2nbx2CpF',
          name: 'NGHTMRE',
          type: 'artist',
          uri: 'spotify:artist:76M2Ekj8bG8W7X2nbx2CpF'
        },
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/20DZAfCuP1TKZl5KcY7z3Q'
          },
          href: 'https://api.spotify.com/v1/artists/20DZAfCuP1TKZl5KcY7z3Q',
          id: '20DZAfCuP1TKZl5KcY7z3Q',
          name: 'SLANDER',
          type: 'artist',
          uri: 'spotify:artist:20DZAfCuP1TKZl5KcY7z3Q'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/1ABYsJwhqu0MoN3HVn3tKi'
      },
      href: 'https://api.spotify.com/v1/albums/1ABYsJwhqu0MoN3HVn3tKi',
      id: '1ABYsJwhqu0MoN3HVn3tKi',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/c05a08c2b9a69ae433bdb8c8b9c5a68935032d7c',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/037a98e0de6bff2fefec08ce511dc4281bd1d2dc',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/d4e702039e79d1c0ceda1a582e8f72e9cb8cfaad',
          width: 64
        }
      ],
      name: 'GUD VIBRATIONS',
      type: 'album',
      uri: 'spotify:album:1ABYsJwhqu0MoN3HVn3tKi'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/76M2Ekj8bG8W7X2nbx2CpF'
        },
        href: 'https://api.spotify.com/v1/artists/76M2Ekj8bG8W7X2nbx2CpF',
        id: '76M2Ekj8bG8W7X2nbx2CpF',
        name: 'NGHTMRE',
        type: 'artist',
        uri: 'spotify:artist:76M2Ekj8bG8W7X2nbx2CpF'
      },
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/20DZAfCuP1TKZl5KcY7z3Q'
        },
        href: 'https://api.spotify.com/v1/artists/20DZAfCuP1TKZl5KcY7z3Q',
        id: '20DZAfCuP1TKZl5KcY7z3Q',
        name: 'SLANDER',
        type: 'artist',
        uri: 'spotify:artist:20DZAfCuP1TKZl5KcY7z3Q'
      }
    ],
    disc_number: 1,
    duration_ms: 224210,
    explicit: false,
    external_ids: {
      isrc: 'USZ4V1600245'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/2BVUOGciUUUqOPSLtHwLGp'
    },
    href: 'https://api.spotify.com/v1/tracks/2BVUOGciUUUqOPSLtHwLGp',
    id: '2BVUOGciUUUqOPSLtHwLGp',
    is_playable: true,
    name: 'GUD VIBRATIONS',
    popularity: 62,
    preview_url:
      'https://p.scdn.co/mp3-preview/b29796ac241e6ea2581ad05c10cc49957d3039e5?cid=774b29d4f13844c495f206cafdad9c86',
    track_number: 1,
    type: 'track',
    uri: 'spotify:track:2BVUOGciUUUqOPSLtHwLGp'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/11gWrKZMBsGQWmobv3oNfW'
          },
          href: 'https://api.spotify.com/v1/artists/11gWrKZMBsGQWmobv3oNfW',
          id: '11gWrKZMBsGQWmobv3oNfW',
          name: 'Alison Wonderland',
          type: 'artist',
          uri: 'spotify:artist:11gWrKZMBsGQWmobv3oNfW'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/6Jwpxghteb64iHg6ftMnNo'
      },
      href: 'https://api.spotify.com/v1/albums/6Jwpxghteb64iHg6ftMnNo',
      id: '6Jwpxghteb64iHg6ftMnNo',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/7821798baf0204a93b62759ff50db754eac7ac43',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/f4a2ddd7f207e9ac9e3085a2b8b3b6bc990412de',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/c72892118b8126b18c127d14d203ef0bec8dc2a1',
          width: 64
        }
      ],
      name: 'Awake',
      type: 'album',
      uri: 'spotify:album:6Jwpxghteb64iHg6ftMnNo'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/11gWrKZMBsGQWmobv3oNfW'
        },
        href: 'https://api.spotify.com/v1/artists/11gWrKZMBsGQWmobv3oNfW',
        id: '11gWrKZMBsGQWmobv3oNfW',
        name: 'Alison Wonderland',
        type: 'artist',
        uri: 'spotify:artist:11gWrKZMBsGQWmobv3oNfW'
      }
    ],
    disc_number: 1,
    duration_ms: 183912,
    explicit: false,
    external_ids: {
      isrc: 'AUUM71700693'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/6Apozxrk03AIyQwyswUjbt'
    },
    href: 'https://api.spotify.com/v1/tracks/6Apozxrk03AIyQwyswUjbt',
    id: '6Apozxrk03AIyQwyswUjbt',
    is_playable: true,
    name: 'Church',
    popularity: 61,
    preview_url: null,
    track_number: 7,
    type: 'track',
    uri: 'spotify:track:6Apozxrk03AIyQwyswUjbt'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/69GGBxA162lTqCwzJG5jLp'
          },
          href: 'https://api.spotify.com/v1/artists/69GGBxA162lTqCwzJG5jLp',
          id: '69GGBxA162lTqCwzJG5jLp',
          name: 'The Chainsmokers',
          type: 'artist',
          uri: 'spotify:artist:69GGBxA162lTqCwzJG5jLp'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/0rSLgV8p5FzfnqlEk4GzxE'
      },
      href: 'https://api.spotify.com/v1/albums/0rSLgV8p5FzfnqlEk4GzxE',
      id: '0rSLgV8p5FzfnqlEk4GzxE',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/512bd22e2bc73f9883b8612daf4f23acaac3c776',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/2e244b9284d317b2019bb9fd44d9a086210d4974',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/57ba46d39d710e99ae524b279cae3a3981ace43f',
          width: 64
        }
      ],
      name: 'Closer',
      type: 'album',
      uri: 'spotify:album:0rSLgV8p5FzfnqlEk4GzxE'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/69GGBxA162lTqCwzJG5jLp'
        },
        href: 'https://api.spotify.com/v1/artists/69GGBxA162lTqCwzJG5jLp',
        id: '69GGBxA162lTqCwzJG5jLp',
        name: 'The Chainsmokers',
        type: 'artist',
        uri: 'spotify:artist:69GGBxA162lTqCwzJG5jLp'
      },
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/26VFTg2z8YR0cCuwLzESi2'
        },
        href: 'https://api.spotify.com/v1/artists/26VFTg2z8YR0cCuwLzESi2',
        id: '26VFTg2z8YR0cCuwLzESi2',
        name: 'Halsey',
        type: 'artist',
        uri: 'spotify:artist:26VFTg2z8YR0cCuwLzESi2'
      }
    ],
    disc_number: 1,
    duration_ms: 244960,
    explicit: false,
    external_ids: {
      isrc: 'USQX91601347'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/7BKLCZ1jbUBVqRi2FVlTVw'
    },
    href: 'https://api.spotify.com/v1/tracks/7BKLCZ1jbUBVqRi2FVlTVw',
    id: '7BKLCZ1jbUBVqRi2FVlTVw',
    is_playable: true,
    name: 'Closer',
    popularity: 85,
    preview_url:
      'https://p.scdn.co/mp3-preview/8d3df1c64907cb183bff5a127b1525b530992afb?cid=774b29d4f13844c495f206cafdad9c86',
    track_number: 1,
    type: 'track',
    uri: 'spotify:track:7BKLCZ1jbUBVqRi2FVlTVw'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/4D75GcNG95ebPtNvoNVXhz'
          },
          href: 'https://api.spotify.com/v1/artists/4D75GcNG95ebPtNvoNVXhz',
          id: '4D75GcNG95ebPtNvoNVXhz',
          name: 'Afrojack',
          type: 'artist',
          uri: 'spotify:artist:4D75GcNG95ebPtNvoNVXhz'
        },
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/1Cs0zKBU1kc0i8ypK3B9ai'
          },
          href: 'https://api.spotify.com/v1/artists/1Cs0zKBU1kc0i8ypK3B9ai',
          id: '1Cs0zKBU1kc0i8ypK3B9ai',
          name: 'David Guetta',
          type: 'artist',
          uri: 'spotify:artist:1Cs0zKBU1kc0i8ypK3B9ai'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/0U4q7p1va4s5LC3zRO4Mw1'
      },
      href: 'https://api.spotify.com/v1/albums/0U4q7p1va4s5LC3zRO4Mw1',
      id: '0U4q7p1va4s5LC3zRO4Mw1',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/51c4171f023627f2e6a08ae090fe9accc444eb17',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/b8bab7bc21d521f06f1030c2c25bc4c74f62893a',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/9684427ddf0ec4c1d7aa33e65681c46195e6b5ed',
          width: 64
        }
      ],
      name: 'Another Life',
      type: 'album',
      uri: 'spotify:album:0U4q7p1va4s5LC3zRO4Mw1'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/4D75GcNG95ebPtNvoNVXhz'
        },
        href: 'https://api.spotify.com/v1/artists/4D75GcNG95ebPtNvoNVXhz',
        id: '4D75GcNG95ebPtNvoNVXhz',
        name: 'Afrojack',
        type: 'artist',
        uri: 'spotify:artist:4D75GcNG95ebPtNvoNVXhz'
      },
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/1Cs0zKBU1kc0i8ypK3B9ai'
        },
        href: 'https://api.spotify.com/v1/artists/1Cs0zKBU1kc0i8ypK3B9ai',
        id: '1Cs0zKBU1kc0i8ypK3B9ai',
        name: 'David Guetta',
        type: 'artist',
        uri: 'spotify:artist:1Cs0zKBU1kc0i8ypK3B9ai'
      },
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/0v2Y5jwtcv8LiWNTRls1KM'
        },
        href: 'https://api.spotify.com/v1/artists/0v2Y5jwtcv8LiWNTRls1KM',
        id: '0v2Y5jwtcv8LiWNTRls1KM',
        name: 'Ester Dean',
        type: 'artist',
        uri: 'spotify:artist:0v2Y5jwtcv8LiWNTRls1KM'
      }
    ],
    disc_number: 1,
    duration_ms: 208689,
    explicit: false,
    external_ids: {
      isrc: 'CYA221700023'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/0AOEd0Zw22aTE8LzsS4EMg'
    },
    href: 'https://api.spotify.com/v1/tracks/0AOEd0Zw22aTE8LzsS4EMg',
    id: '0AOEd0Zw22aTE8LzsS4EMg',
    is_playable: true,
    name: 'Another Life',
    popularity: 62,
    preview_url: null,
    track_number: 1,
    type: 'track',
    uri: 'spotify:track:0AOEd0Zw22aTE8LzsS4EMg'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/4ehtJnVumNf6xzSCDk8aLB'
          },
          href: 'https://api.spotify.com/v1/artists/4ehtJnVumNf6xzSCDk8aLB',
          id: '4ehtJnVumNf6xzSCDk8aLB',
          name: 'Martin Jensen',
          type: 'artist',
          uri: 'spotify:artist:4ehtJnVumNf6xzSCDk8aLB'
        },
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/188VINPQh5dyNfLUkevKqf'
          },
          href: 'https://api.spotify.com/v1/artists/188VINPQh5dyNfLUkevKqf',
          id: '188VINPQh5dyNfLUkevKqf',
          name: 'Olivia Holt',
          type: 'artist',
          uri: 'spotify:artist:188VINPQh5dyNfLUkevKqf'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/6UlmrJanLPDRZdgj6nIUp9'
      },
      href: 'https://api.spotify.com/v1/albums/6UlmrJanLPDRZdgj6nIUp9',
      id: '6UlmrJanLPDRZdgj6nIUp9',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/7ae122630e09fd91c1a051df7b912d520309f0b1',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/194fe3377a6ace44de4077defba7ab10673b3a50',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/3807e98e58c409e630efbf6ce6f89d98b3f868d9',
          width: 64
        }
      ],
      name: '16 Steps',
      type: 'album',
      uri: 'spotify:album:6UlmrJanLPDRZdgj6nIUp9'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/4ehtJnVumNf6xzSCDk8aLB'
        },
        href: 'https://api.spotify.com/v1/artists/4ehtJnVumNf6xzSCDk8aLB',
        id: '4ehtJnVumNf6xzSCDk8aLB',
        name: 'Martin Jensen',
        type: 'artist',
        uri: 'spotify:artist:4ehtJnVumNf6xzSCDk8aLB'
      },
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/188VINPQh5dyNfLUkevKqf'
        },
        href: 'https://api.spotify.com/v1/artists/188VINPQh5dyNfLUkevKqf',
        id: '188VINPQh5dyNfLUkevKqf',
        name: 'Olivia Holt',
        type: 'artist',
        uri: 'spotify:artist:188VINPQh5dyNfLUkevKqf'
      }
    ],
    disc_number: 1,
    duration_ms: 208022,
    explicit: false,
    external_ids: {
      isrc: 'DK4YA1807901'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/7v3MkCal9v1Bw0N31X33qA'
    },
    href: 'https://api.spotify.com/v1/tracks/7v3MkCal9v1Bw0N31X33qA',
    id: '7v3MkCal9v1Bw0N31X33qA',
    is_playable: true,
    name: '16 Steps',
    popularity: 68,
    preview_url: null,
    track_number: 1,
    type: 'track',
    uri: 'spotify:track:7v3MkCal9v1Bw0N31X33qA'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/64KEffDW9EtZ1y2vBYgq8T'
          },
          href: 'https://api.spotify.com/v1/artists/64KEffDW9EtZ1y2vBYgq8T',
          id: '64KEffDW9EtZ1y2vBYgq8T',
          name: 'Marshmello',
          type: 'artist',
          uri: 'spotify:artist:64KEffDW9EtZ1y2vBYgq8T'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/6opKASPALOkPwCfHvqIS9H'
      },
      href: 'https://api.spotify.com/v1/albums/6opKASPALOkPwCfHvqIS9H',
      id: '6opKASPALOkPwCfHvqIS9H',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/b644a5bdfadc8a70e0ee4142fd5b0e60b0485fd5',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/8ca498c613ec066845c4b7e7d5b93c7a3765ac3e',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/5b5e914d1eeee8cf6aadd7fd1a1865806a531c1b',
          width: 64
        }
      ],
      name: 'Joytime',
      type: 'album',
      uri: 'spotify:album:6opKASPALOkPwCfHvqIS9H'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/64KEffDW9EtZ1y2vBYgq8T'
        },
        href: 'https://api.spotify.com/v1/artists/64KEffDW9EtZ1y2vBYgq8T',
        id: '64KEffDW9EtZ1y2vBYgq8T',
        name: 'Marshmello',
        type: 'artist',
        uri: 'spotify:artist:64KEffDW9EtZ1y2vBYgq8T'
      }
    ],
    disc_number: 1,
    duration_ms: 212571,
    explicit: false,
    external_ids: {
      isrc: 'TCACK1581187'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/05KizhJc5qATFI2D7SauJ5'
    },
    href: 'https://api.spotify.com/v1/tracks/05KizhJc5qATFI2D7SauJ5',
    id: '05KizhJc5qATFI2D7SauJ5',
    is_playable: true,
    name: 'Bounce',
    popularity: 57,
    preview_url:
      'https://p.scdn.co/mp3-preview/8e1e118b434bf08b6d62822429089dad73f5fe7e?cid=774b29d4f13844c495f206cafdad9c86',
    track_number: 5,
    type: 'track',
    uri: 'spotify:track:05KizhJc5qATFI2D7SauJ5'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/6cEuCEZu7PAE9ZSzLLc2oQ'
          },
          href: 'https://api.spotify.com/v1/artists/6cEuCEZu7PAE9ZSzLLc2oQ',
          id: '6cEuCEZu7PAE9ZSzLLc2oQ',
          name: 'R3HAB',
          type: 'artist',
          uri: 'spotify:artist:6cEuCEZu7PAE9ZSzLLc2oQ'
        },
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/4CrDEHL7ysNabeYvL3xjUX'
          },
          href: 'https://api.spotify.com/v1/artists/4CrDEHL7ysNabeYvL3xjUX',
          id: '4CrDEHL7ysNabeYvL3xjUX',
          name: 'Skytech',
          type: 'artist',
          uri: 'spotify:artist:4CrDEHL7ysNabeYvL3xjUX'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/4j1R4amgY1UnnIQ2sRxD6j'
      },
      href: 'https://api.spotify.com/v1/albums/4j1R4amgY1UnnIQ2sRxD6j',
      id: '4j1R4amgY1UnnIQ2sRxD6j',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/366cf623c9411bc04933d32eee43fa83d20d8e01',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/c984acc8074d8960cc660f7421d3a1307cfde0f1',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/c0f70534f45a74523bd579b2b872999a2db1e25a',
          width: 64
        }
      ],
      name: 'Starflight',
      type: 'album',
      uri: 'spotify:album:4j1R4amgY1UnnIQ2sRxD6j'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/6cEuCEZu7PAE9ZSzLLc2oQ'
        },
        href: 'https://api.spotify.com/v1/artists/6cEuCEZu7PAE9ZSzLLc2oQ',
        id: '6cEuCEZu7PAE9ZSzLLc2oQ',
        name: 'R3HAB',
        type: 'artist',
        uri: 'spotify:artist:6cEuCEZu7PAE9ZSzLLc2oQ'
      },
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/4CrDEHL7ysNabeYvL3xjUX'
        },
        href: 'https://api.spotify.com/v1/artists/4CrDEHL7ysNabeYvL3xjUX',
        id: '4CrDEHL7ysNabeYvL3xjUX',
        name: 'Skytech',
        type: 'artist',
        uri: 'spotify:artist:4CrDEHL7ysNabeYvL3xjUX'
      }
    ],
    disc_number: 1,
    duration_ms: 154442,
    explicit: false,
    external_ids: {
      isrc: 'NLW4L1800035'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/2ayFvkO2Nq2lkfiKXDB08h'
    },
    href: 'https://api.spotify.com/v1/tracks/2ayFvkO2Nq2lkfiKXDB08h',
    id: '2ayFvkO2Nq2lkfiKXDB08h',
    is_playable: true,
    name: 'Starflight',
    popularity: 63,
    preview_url:
      'https://p.scdn.co/mp3-preview/013f99765a515d9c2b4be5108251a60a9dedccb6?cid=774b29d4f13844c495f206cafdad9c86',
    track_number: 1,
    type: 'track',
    uri: 'spotify:track:2ayFvkO2Nq2lkfiKXDB08h'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/20gsENnposVs2I4rQ5kvrf'
          },
          href: 'https://api.spotify.com/v1/artists/20gsENnposVs2I4rQ5kvrf',
          id: '20gsENnposVs2I4rQ5kvrf',
          name: 'Sam Feldt',
          type: 'artist',
          uri: 'spotify:artist:20gsENnposVs2I4rQ5kvrf'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/0yFouohH1JicKkRcYggdOP'
      },
      href: 'https://api.spotify.com/v1/albums/0yFouohH1JicKkRcYggdOP',
      id: '0yFouohH1JicKkRcYggdOP',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/3b7d89dae291817bfcac4f17ad19a5b15c4c4672',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/3e9c439094b9962a327956b38189fe131ef58c47',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/1c07f1c95b65a8829e8d0a896320a9b92bcd9933',
          width: 64
        }
      ],
      name: 'Wishing Well',
      type: 'album',
      uri: 'spotify:album:0yFouohH1JicKkRcYggdOP'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/20gsENnposVs2I4rQ5kvrf'
        },
        href: 'https://api.spotify.com/v1/artists/20gsENnposVs2I4rQ5kvrf',
        id: '20gsENnposVs2I4rQ5kvrf',
        name: 'Sam Feldt',
        type: 'artist',
        uri: 'spotify:artist:20gsENnposVs2I4rQ5kvrf'
      },
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/0DCRUk25XIiRFiNtiuR8OR'
        },
        href: 'https://api.spotify.com/v1/artists/0DCRUk25XIiRFiNtiuR8OR',
        id: '0DCRUk25XIiRFiNtiuR8OR',
        name: 'Olivia Sebastianelli',
        type: 'artist',
        uri: 'spotify:artist:0DCRUk25XIiRFiNtiuR8OR'
      }
    ],
    disc_number: 1,
    duration_ms: 186610,
    explicit: false,
    external_ids: {
      isrc: 'NLZ541701232'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/1r41uqRIKP01b00iFqTnNh'
    },
    href: 'https://api.spotify.com/v1/tracks/1r41uqRIKP01b00iFqTnNh',
    id: '1r41uqRIKP01b00iFqTnNh',
    is_playable: true,
    name: 'Wishing Well',
    popularity: 62,
    preview_url:
      'https://p.scdn.co/mp3-preview/d84294a0587b89d3e10f50d68b654523ec0a1617?cid=774b29d4f13844c495f206cafdad9c86',
    track_number: 1,
    type: 'track',
    uri: 'spotify:track:1r41uqRIKP01b00iFqTnNh'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/5X4LWwbUFNzPkEas04uU82'
          },
          href: 'https://api.spotify.com/v1/artists/5X4LWwbUFNzPkEas04uU82',
          id: '5X4LWwbUFNzPkEas04uU82',
          name: 'DVBBS',
          type: 'artist',
          uri: 'spotify:artist:5X4LWwbUFNzPkEas04uU82'
        },
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/2cFrymmkijnjDg9SS92EPM'
          },
          href: 'https://api.spotify.com/v1/artists/2cFrymmkijnjDg9SS92EPM',
          id: '2cFrymmkijnjDg9SS92EPM',
          name: 'Blackbear',
          type: 'artist',
          uri: 'spotify:artist:2cFrymmkijnjDg9SS92EPM'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/5XZ80YbIhMctMkIHzZBB0a'
      },
      href: 'https://api.spotify.com/v1/albums/5XZ80YbIhMctMkIHzZBB0a',
      id: '5XZ80YbIhMctMkIHzZBB0a',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/2ec3646fb45da2d917bfb30966e30e4a15cc66ae',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/dd54bdfc4c0f9c46b7cb5866b1b4c42a71f515c1',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/6988f430b1dcd55402dcb5263c63ed8a27300f5e',
          width: 64
        }
      ],
      name: 'IDWK',
      type: 'album',
      uri: 'spotify:album:5XZ80YbIhMctMkIHzZBB0a'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/5X4LWwbUFNzPkEas04uU82'
        },
        href: 'https://api.spotify.com/v1/artists/5X4LWwbUFNzPkEas04uU82',
        id: '5X4LWwbUFNzPkEas04uU82',
        name: 'DVBBS',
        type: 'artist',
        uri: 'spotify:artist:5X4LWwbUFNzPkEas04uU82'
      },
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/2cFrymmkijnjDg9SS92EPM'
        },
        href: 'https://api.spotify.com/v1/artists/2cFrymmkijnjDg9SS92EPM',
        id: '2cFrymmkijnjDg9SS92EPM',
        name: 'Blackbear',
        type: 'artist',
        uri: 'spotify:artist:2cFrymmkijnjDg9SS92EPM'
      }
    ],
    disc_number: 1,
    duration_ms: 179999,
    explicit: false,
    external_ids: {
      isrc: 'USUS11800138'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/4ABdTWafMCXfATpILRuZFW'
    },
    href: 'https://api.spotify.com/v1/tracks/4ABdTWafMCXfATpILRuZFW',
    id: '4ABdTWafMCXfATpILRuZFW',
    is_playable: true,
    name: 'IDWK',
    popularity: 74,
    preview_url:
      'https://p.scdn.co/mp3-preview/7662dd08545d8dbfa88fe53bdc6c97bfb58dc790?cid=774b29d4f13844c495f206cafdad9c86',
    track_number: 1,
    type: 'track',
    uri: 'spotify:track:4ABdTWafMCXfATpILRuZFW'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/69GGBxA162lTqCwzJG5jLp'
          },
          href: 'https://api.spotify.com/v1/artists/69GGBxA162lTqCwzJG5jLp',
          id: '69GGBxA162lTqCwzJG5jLp',
          name: 'The Chainsmokers',
          type: 'artist',
          uri: 'spotify:artist:69GGBxA162lTqCwzJG5jLp'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/4JPguzRps3kuWDD5GS6oXr'
      },
      href: 'https://api.spotify.com/v1/albums/4JPguzRps3kuWDD5GS6oXr',
      id: '4JPguzRps3kuWDD5GS6oXr',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/df3b17e748de56e4ce78ac29b216d3f99afd0c5a',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/ec1d389f4b448463b81513c0c5d5e1f6c34faa63',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/a2ec1de801d5a1e07123750e0216306a6e9c7d80',
          width: 64
        }
      ],
      name: 'Memories...Do Not Open',
      type: 'album',
      uri: 'spotify:album:4JPguzRps3kuWDD5GS6oXr'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/69GGBxA162lTqCwzJG5jLp'
        },
        href: 'https://api.spotify.com/v1/artists/69GGBxA162lTqCwzJG5jLp',
        id: '69GGBxA162lTqCwzJG5jLp',
        name: 'The Chainsmokers',
        type: 'artist',
        uri: 'spotify:artist:69GGBxA162lTqCwzJG5jLp'
      }
    ],
    disc_number: 1,
    duration_ms: 224280,
    explicit: true,
    external_ids: {
      isrc: 'USQX91700581'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/26AuyrZGzWWiYZPSd3XBIg'
    },
    href: 'https://api.spotify.com/v1/tracks/26AuyrZGzWWiYZPSd3XBIg',
    id: '26AuyrZGzWWiYZPSd3XBIg',
    is_playable: true,
    name: 'Bloodstream',
    popularity: 63,
    preview_url:
      'https://p.scdn.co/mp3-preview/84fb88b30831f89f33fe458219a036db149679a5?cid=774b29d4f13844c495f206cafdad9c86',
    track_number: 3,
    type: 'track',
    uri: 'spotify:track:26AuyrZGzWWiYZPSd3XBIg'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/4YXycRbyyAE0wozTk7QMEq'
          },
          href: 'https://api.spotify.com/v1/artists/4YXycRbyyAE0wozTk7QMEq',
          id: '4YXycRbyyAE0wozTk7QMEq',
          name: 'Matoma',
          type: 'artist',
          uri: 'spotify:artist:4YXycRbyyAE0wozTk7QMEq'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/5FAgkqm09atYktUn6owa2q'
      },
      href: 'https://api.spotify.com/v1/albums/5FAgkqm09atYktUn6owa2q',
      id: '5FAgkqm09atYktUn6owa2q',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/d40f6c9290a0608cc18d036adc3ba7bb382ca8ed',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/3cc1ee74eb6027f79ffeeab5e62d72041f61736c',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/5fe98ffd8455b041ebaa506482fb668eccd390ea',
          width: 64
        }
      ],
      name: 'One In A Million',
      type: 'album',
      uri: 'spotify:album:5FAgkqm09atYktUn6owa2q'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/4YXycRbyyAE0wozTk7QMEq'
        },
        href: 'https://api.spotify.com/v1/artists/4YXycRbyyAE0wozTk7QMEq',
        id: '4YXycRbyyAE0wozTk7QMEq',
        name: 'Matoma',
        type: 'artist',
        uri: 'spotify:artist:4YXycRbyyAE0wozTk7QMEq'
      },
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/1bqxdqvUtPWZri43cKHac8'
        },
        href: 'https://api.spotify.com/v1/artists/1bqxdqvUtPWZri43cKHac8',
        id: '1bqxdqvUtPWZri43cKHac8',
        name: 'MAX',
        type: 'artist',
        uri: 'spotify:artist:1bqxdqvUtPWZri43cKHac8'
      }
    ],
    disc_number: 1,
    duration_ms: 167438,
    explicit: true,
    external_ids: {
      isrc: 'GBAYE1800298'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/4cYXhuR8yc3lzzkcwAfsgS'
    },
    href: 'https://api.spotify.com/v1/tracks/4cYXhuR8yc3lzzkcwAfsgS',
    id: '4cYXhuR8yc3lzzkcwAfsgS',
    is_playable: true,
    linked_from: {
      external_urls: {
        spotify: 'https://open.spotify.com/track/0IL20mzbwXaGVRrcan6AOB'
      },
      href: 'https://api.spotify.com/v1/tracks/0IL20mzbwXaGVRrcan6AOB',
      id: '0IL20mzbwXaGVRrcan6AOB',
      type: 'track',
      uri: 'spotify:track:0IL20mzbwXaGVRrcan6AOB'
    },
    name: 'Lonely (feat. MAX)',
    popularity: 49,
    preview_url:
      'https://p.scdn.co/mp3-preview/582a08e9ecb957180cd6d4fa332617c307545a65?cid=774b29d4f13844c495f206cafdad9c86',
    track_number: 8,
    type: 'track',
    uri: 'spotify:track:4cYXhuR8yc3lzzkcwAfsgS'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/64KEffDW9EtZ1y2vBYgq8T'
          },
          href: 'https://api.spotify.com/v1/artists/64KEffDW9EtZ1y2vBYgq8T',
          id: '64KEffDW9EtZ1y2vBYgq8T',
          name: 'Marshmello',
          type: 'artist',
          uri: 'spotify:artist:64KEffDW9EtZ1y2vBYgq8T'
        },
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/6LuN9FCkKOj5PcnpouEgny'
          },
          href: 'https://api.spotify.com/v1/artists/6LuN9FCkKOj5PcnpouEgny',
          id: '6LuN9FCkKOj5PcnpouEgny',
          name: 'Khalid',
          type: 'artist',
          uri: 'spotify:artist:6LuN9FCkKOj5PcnpouEgny'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/2bw00gRKNKbTFOqCkohbSh'
      },
      href: 'https://api.spotify.com/v1/albums/2bw00gRKNKbTFOqCkohbSh',
      id: '2bw00gRKNKbTFOqCkohbSh',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/2ce516d3f99db708defab97b4294d95bea27cd9f',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/575096dbcc1e23cca60ec973168fa4cc16a4c4de',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/84edf92a05bc2014844cc09b7a4ab841f67ffd90',
          width: 64
        }
      ],
      name: 'Silence',
      type: 'album',
      uri: 'spotify:album:2bw00gRKNKbTFOqCkohbSh'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/64KEffDW9EtZ1y2vBYgq8T'
        },
        href: 'https://api.spotify.com/v1/artists/64KEffDW9EtZ1y2vBYgq8T',
        id: '64KEffDW9EtZ1y2vBYgq8T',
        name: 'Marshmello',
        type: 'artist',
        uri: 'spotify:artist:64KEffDW9EtZ1y2vBYgq8T'
      },
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/6LuN9FCkKOj5PcnpouEgny'
        },
        href: 'https://api.spotify.com/v1/artists/6LuN9FCkKOj5PcnpouEgny',
        id: '6LuN9FCkKOj5PcnpouEgny',
        name: 'Khalid',
        type: 'artist',
        uri: 'spotify:artist:6LuN9FCkKOj5PcnpouEgny'
      }
    ],
    disc_number: 1,
    duration_ms: 180822,
    explicit: false,
    external_ids: {
      isrc: 'USRC11701901'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/7vGuf3Y35N4wmASOKLUVVU'
    },
    href: 'https://api.spotify.com/v1/tracks/7vGuf3Y35N4wmASOKLUVVU',
    id: '7vGuf3Y35N4wmASOKLUVVU',
    is_playable: true,
    name: 'Silence',
    popularity: 84,
    preview_url:
      'https://p.scdn.co/mp3-preview/d779881bd6bbcced00dbf7f5b87e3374bf7c058b?cid=774b29d4f13844c495f206cafdad9c86',
    track_number: 1,
    type: 'track',
    uri: 'spotify:track:7vGuf3Y35N4wmASOKLUVVU'
  }
];



// WEBPACK FOOTER //
// ./src/utils/data/marshmello.js